import { defineRecipe } from "@chakra-ui/react";

export const textRecipe = defineRecipe({
  base: {
    colorPalette: "neutral",
    color: "neutral.600",
    letterSpacing: "-0.03em",
  },
  variants: {
    visual: {
      primary: {
        fontStyle: "sm",
        fontFamily: "body",
      },
    },
  },
  defaultVariants: {
    visual: "primary",
  },
});
